import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { vendor as vendorApi } from '../../../api';
import { VendorDetailContext } from '../../../contexts';
import { useApi, useAuth } from '../../../hooks';
import { VendorPaymentScheduleSchema } from '../../../schemas/Vendor';
import { PermissionKey } from '../../../types';
import { EditCardSkeleton } from '../../Card';
import { PaymentScheduleForm } from './PaymentScheduleForm';

export const PaymentScheduleAdmin = () => {
  const { hasPermissions } = useAuth();
  const { t } = useTranslation();
  const { vendor, vendorId } = useContext(VendorDetailContext);
  const { data, isLoading, refresh } = useApi(vendorApi.getPaymentSchedule, null, vendorId);
  const { call } = useApi(vendorApi.updatePaymentSchedule, { successKey: 'common:success.save' });

  return (
    <EditCardSkeleton
      readOnly={!hasPermissions(PermissionKey.VendorEditFinancial)}
      entity={data}
      isLoading={isLoading}
      title={t('vendor:financials.sections.paymentSchedule')}
      disabled={vendor?.isArchived}
      schema={VendorPaymentScheduleSchema()}
      onSave={call}
      onConfirm={() => refresh()}
      showModifiedDate
    >
      <PaymentScheduleForm />
    </EditCardSkeleton>
  );
};
